import i18n from 'common/i18n'

const getExceptionMessage = (err: any) => {
  return (
    i18n.exceptions[err?.exception as keyof typeof i18n.exceptions] ||
    i18n.errors.errorBoundary
  )
}

export { getExceptionMessage }
